// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"d39f6052","325":"c45bafd0","715":"7f03bf05"}[chunkId] + ".chunk.css";
};